<template>
  <div class="ds-control mobile ds_teas_batch_occupation">
    <div class="batch_occupation_head">
      <div class="head_select" @click="chooseField">
        <span>{{name}}</span>
        <i class="iconfont icon-xiajiantou"></i>
      </div>
    </div>
    <div class="batch_occupation_date">
      <i class="iconfont icon-zuo" @click="lastWeek"></i>
      <span>{{monday | dateFormat}}～{{sunday | dateFormat}}</span>
      <i class="iconfont icon-weibiaoti34" @click="nextWeek"></i>
    </div>
    <div class="batch_occupation_content">
      <div class="content_head">
        <div class="head_date">日期</div>
        <div class="head_wb" v-for="(noonItem,noonIndex) of noons" :key="noonIndex">{{noonItem.text}}</div>
      </div>
      <div class="content_week" v-for="(item,index) of list" :key="index">
        <div class="week_value">
          <div>{{weeks[index]}}</div>
          <span>{{item.date | getDate}}</span>
        </div>
        <div class="week_list">
          <div v-for="(noonItem,noonIndex) of noons" :key="noonIndex" :class="getIcon(item,noonItem) + '-color'" @click="noonClick(item,noonItem)">
            <i class="iconfont" :class="getIcon(item,noonItem)"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 选择场地 -->
    <dsf-mobile-select-field :show="showSelectField" :select-all="false" @close="showSelectField=false" @choose-data="chooseData" :echoData="selectField"></dsf-mobile-select-field>
    <!-- 占用编辑 -->
    <DsfOccupyDialog :show="showDialog" @close="showDialog=false" :value="dialogDetail" @addValue="addValue" @editValue="editValue" @releaseOccupation="releaseOccupation"></DsfOccupyDialog>
    <DsfOccupyPopup :show="showOccupyEdit" :isEdit="isEdit" @close="showOccupyEdit=false" :value="occupyDetail" @submit="occupySubmit"></DsfOccupyPopup>
  </div>
</template>

<script>
import DsfOccupyDialog from "./occupyDialog.vue";
import DsfOccupyPopup from "./occupyPopup.vue";
export default dsf.component({
  name: "DsfMobileBatchOccupation",
  ctrlCaption: "资源占用列表",
  mixins: [$mixins.control],
  components: { DsfOccupyDialog, DsfOccupyPopup },
  data() {
    return {
      monday: '',
      sunday: '',
      id: '',
      name: '',
      showSelectField: false,
      selectField: [],
      list: [],
      noons: [],
      resources: [],
      weeks: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      showDialog: false,
      showOccupyEdit: false,
      dialogDetail: {},
      isEdit: false,//是否为编辑

    }
  },
  filters: {
    dateFormat(val) {
      if (val.length >= 8) {
        let arr = val.split('-');
        return `${arr[1]}月${arr[2]}日`
      } else {
        return val
      }
    },
    getDate(val) {
      return val.substring(val.length - 5)
    }
  },
  props: {
    sourcesUrl: {
      type: String,
      default: '/resource/occupy/queryResourceOccupyTable',
    }
  },
  methods: {
    // 选择场地
    chooseField() {
      this.selectField = [this.id]
      this.showSelectField = true;
    },
    // 弹窗新增
    addValue(val) {
      this.occupyDetail = val;
      this.isEdit = false;
      this.showDialog = false;
      this.showOccupyEdit = true;
    },
    // 弹窗编辑
    editValue(val) {
      this.occupyDetail = val;
      this.isEdit = true;
      this.showDialog = false;
      this.showOccupyEdit = true;
    },
    releaseOccupation() {
      this.showDialog = false;
      this.getList()
    },
    occupySubmit() {
      this.showOccupyEdit = false;
      this.getList()
    },
    chooseData(val) {
      if (val.length) {
        this.name = val[0].name || '';
        this.id = val[0].id;
        this.getList()
      }
      this.showSelectField = false;
    },
    getList() {
      this.$http
        .get(this.$replace(this.sourcesUrl, this), {
          pid: this.id,
          startDate: this.monday,
          endDate: this.sunday
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            this.washData(res.data)
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
        });
    },
    // 清洗数据
    washData(val) {
      console.log(val);
      this.list = val.list;
      this.noons = val.noons;
      this.resources = val.resources;
    },
    getIcon(item, noonItem) {
      let statusValue = this.resources[0]?.statusValue;
      let iconName = ""
      if (statusValue == '1') {
        if (item.info && item.info.length) {
          iconName = 'icon-icon-kx'
          item.info.forEach(element => {
            if (element.noon == noonItem.id) {
              if (element.state == 1) {
                iconName = 'icon-icon-yk'
              } else if (element.state == 2) {
                iconName = 'icon-icon-tips'
              } else if (element.state == 3) {
                iconName = 'icon-icon-czr'
              }
            }
          });
        } else {
          iconName = 'icon-icon-kx'
        }
      } else {
        iconName = 'icon-icon-jy'
      }
      return iconName
    },
    // 触发详情弹窗
    noonClick(item, noonItem) {
      let statusValue = this.resources[0]?.statusValue;
      if (statusValue == '1') {
        if (item.info && item.info.length) {
          let noonObject = {};
          item.info.forEach((element) => {
            noonObject[element.noon] = element;
          })
          if (noonObject[noonItem.id]) {
            this.dialogDetail = {
              ...noonObject[noonItem.id],
              relName: this.resources[0].relName,
              name: this.resources[0].name,
              startDate: item.date + ' ' + noonItem.startTime,
              endDate: item.date + ' ' + noonItem.endTime,
            };
            this.showDialog = true;
          } else {
            this.occupyDetail = {
              startDate: item.date + ' ' + noonItem.startTime,
              endDate: item.date + ' ' + noonItem.endTime,
              relName: this.resources[0].relName,
              name: this.resources[0].name,
              id: this.resources[0].id,
              phone: '',
              contacts: '',
              reason: ''
            }
            this.isEdit = false;
            this.showOccupyEdit = true;
          }
        } else {
          this.occupyDetail = {
            startDate: item.date + ' ' + noonItem.startTime,
            endDate: item.date + ' ' + noonItem.endTime,
            relName: this.resources[0].relName,
            name: this.resources[0].name,
            id: this.resources[0].id,
            phone: '',
            contacts: '',
            reason: ''
          }
          this.isEdit = false;
          this.showOccupyEdit = true;
        }
      }
    },
    // 获取上一周
    lastWeek() {
      let day = new Date(this.monday);
      let oneDayTime = 24 * 60 * 60 * 1000
      console.log(day.getTime(), oneDayTime);
      let dayTime = day.getTime() - oneDayTime;
      this.getWeekDate(dayTime)
    },
    // 获取下一周时间
    nextWeek() {
      let day = new Date(this.sunday);
      let oneDayTime = 24 * 60 * 60 * 1000
      let dayTime = day.getTime() + oneDayTime;
      this.getWeekDate(dayTime)
    },
    // 获取时间的周一和周日
    getWeekDate(date) {
      let now = new Date(date);
      let nowTime = now.getTime()
      let day = now.getDay() || 7;
      let oneDayTime = 24 * 60 * 60 * 1000;
      // 本周一时间戳
      let MondayTime = nowTime - (day - 1) * oneDayTime
      // 本周日时间戳
      let SundayTime = nowTime + (7 - day) * oneDayTime
      this.monday = dsf.date.format(new Date(MondayTime), 'yyyy-mm-dd');
      this.sunday = dsf.date.format(new Date(SundayTime), 'yyyy-mm-dd');
      this.getList()
    }
  },
  created() {
    let date = this.queryString.date || '';
    this.id = this.queryString.id || '';
    this.name = this.queryString.name || '';
    if (date) {
      this.getWeekDate(date);
    }
  }
})
</script>

<style>
</style>